export const STATIC_MAP_KEY =
  process.env.REACT_APP_GOOGLE_MAP_KEY?.replace(
    '&libraries=drawing,geometry,places',
    ''
  ) ?? '';
